module.exports = __webpack_public_path__ + "static/media/simu_bg_07.0b44f7e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/simu_bg_07.png
// module id = 1857
// module chunks = 0 1